import React from 'react';
import MenuItem from '../MenuItem/MenuItem';
import { makeLabel } from '../MappedLabel/MappedLabel';

export const makeMenuItems = (valueLabelMap, { emptyItem = false, emptyItemLabel = '', labelKey = '', labels = {}, sort = 1 } = {}) => {
  let map = valueLabelMap;

  if (labelKey) {
    map = map.map((item) => ({
      value: item.value,
      label: makeLabel(labels, `${labelKey}.${item.value}`, item.label),
    }));
  }

  map = map.sort((prev, next) => (prev.label > next.label ? sort : sort * -1));

  if (emptyItem !== false) {
    map = [{ value: emptyItem, label: emptyItemLabel }, ...map];
  }

  return map.map((item) => (
    <MenuItem key={item.value} value={item.value} title={item.label}>
      {item.label}
    </MenuItem>
  ));
};
